import { render, staticRenderFns } from "./editBrowsenew.vue?vue&type=template&id=a517b752&scoped=true&"
import script from "./editBrowsenew.vue?vue&type=script&lang=js&"
export * from "./editBrowsenew.vue?vue&type=script&lang=js&"
import style0 from "./editBrowsenew.vue?vue&type=style&index=0&id=a517b752&lang=less&scoped=true&"
import style1 from "./editBrowsenew.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a517b752",
  null
  
)

export default component.exports